import React, { useContext, useEffect } from 'react'
import { Control, useFieldArray } from 'react-hook-form'

import useServerOrders from '../../../../../api/useServerOrders'
import Check from '../../../../../components/forms/GenericCheck'
import GenericTable, {
  DataTableInterface,
} from '../../../../../components/misc/GenericTable'
import SpinnerLoading from '../../../../../components/misc/SpinnerLoading'
import { formatCalendar, formatCurrency } from '../../../../../utils/helpers'
import { translatePaymetMethods } from '../../../../../utils/translate'
import { RegisterDetailsContext } from '../../RegisterDetailsContainer'

// Interface for prepaid payment form data
interface PrepaidPaymentFormData {
  paymentId: number
  payment: number
  amount: number
  codeCurrency: string
}

interface PartialListInterface {
  control: Control
}

const PrepaidList = ({ control }: PartialListInterface) => {
  const { order } = useContext(RegisterDetailsContext)
  const { isLoading, prepaids, getPrepaids: getPrepaid } = useServerOrders()
  const { fields, append, remove } = useFieldArray({
    name: 'prepaidPayment',
    control,
  })

  // const {
  //   client: { id: clientId },
  // } = order!;
  let clientId: number

  if (order && order.client) {
    const {
      client: { id },
    } = order
    clientId = id
    // Ahora puedes usar clientId
  }

  useEffect(() => {
    getPrepaid({ clientId, status: 'PAID' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPrepaid])

  const changePaidSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      const selected = prepaids.find(
        (paid) => paid.id === Number(e.target.value)
      )
      if (selected) {
        append({
          paymentId: selected.id,
          payment: selected.paymentNumber,
          amount: selected.amount,
          codeCurrency: selected.codeCurrency,
        })
      }
    } else {
      const unSelected = prepaids.findIndex(
        (paid) => paid.id === Number(e.target.value)
      )
      remove(unSelected)
    }
  }
  const titles = ['', 'No. Pago', 'Monto', 'Forma de pago', 'Fecha']

  const tableData: DataTableInterface[] = []
  prepaids.forEach((paid) => {
    tableData.push({
      payload: {
        '': (
          <Check
            defaultChecked={
              !!(fields as unknown as PrepaidPaymentFormData[]).find(
                (item) => item.paymentId === paid.id
              )
            }
            onChange={changePaidSelected}
            value={paid.id}
          />
        ),
        'No. Pago': paid.paymentNumber,
        Monto: formatCurrency(paid.amount, paid.codeCurrency),
        'Forma de pago': translatePaymetMethods(paid.paymentWay),
        Fecha: formatCalendar(paid.createdAt),
      },
    })
  })

  return isLoading ? (
    <div className="flex h-96 w-full items-center justify-center">
      <SpinnerLoading text="Buscando anticipos " />
    </div>
  ) : (
    <div className="mt-5">
      <div className="border-gray mb-5 h-96 overflow-scroll rounded-sm border scrollbar-thin">
        <GenericTable tableData={tableData} tableTitles={titles} />
      </div>

      {/* <Button
        name="Aceptar"
        color="indigo-700"
        full
        action={() => setView()}
      /> */}
    </div>
  )
}

export default PrepaidList
